import { css, SerializedStyles } from '@emotion/react'
import { colors, HFlow, Tag, Theme, useTheme } from 'bold-ui'
import { TitleGroup } from 'components/TitleGroup'
import { AcompanhamentoCondicaoSaudeTematicaEnum } from 'graphql/types.generated'
import { ReactComponent as TriaListIcon } from 'images/acompanhamento/acompanhamento-condicao-saude/ic_tria_listagem.svg'
import { PecTag } from 'view/atendimentos/list/PecTag'

import { useAcompanhamentoCondicaoSaudeContext } from '../../context/AcompanhamentoCondicaoSaudeContext'
import { listaTematicaRecord } from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'
interface AcompanhamentoCondicaoSaudeTableHeaderProps {
  hasTriaFilter: boolean
}

export const AcompanhamentoCondicaoSaudeTableHeader = (props: AcompanhamentoCondicaoSaudeTableHeaderProps) => {
  const { hasTriaFilter } = props
  const { tematica } = useAcompanhamentoCondicaoSaudeContext()

  const theme = useTheme()
  const styles = createStyles(theme)

  const listaTematica = tematica && listaTematicaRecord[tematica]
  const tagStyle = tematica && styles.tagTematica[tematica]

  return (
    <HFlow hSpacing={0.5} style={styles.titleResultadosEncontrados} alignItems='center'>
      <TitleGroup title='Resultados encontrados' />
      {listaTematica && tagStyle && (
        <PecTag icon={listaTematica.icone} style={tagStyle}>
          {listaTematica.titulo}
        </PecTag>
      )}
      {hasTriaFilter && (
        <Tag style={styles.tagTria} icon={TriaListIcon}>
          <span css={styles.textTria}>TRIA</span>
        </Tag>
      )}
    </HFlow>
  )
}

const createTagTematicaStyles = (
  theme: Theme
): Partial<Record<AcompanhamentoCondicaoSaudeTematicaEnum, SerializedStyles>> => ({
  [AcompanhamentoCondicaoSaudeTematicaEnum.GESTANTE_PUERPERA]: css`
    background-color: ${colors.purple.c60};
    color: ${theme.pallete.gray.c100};
  `,
  [AcompanhamentoCondicaoSaudeTematicaEnum.PESSOA_IDOSA]: css`
    background-color: ${colors.green.c60};
    color: ${theme.pallete.gray.c100};
  `,
  [AcompanhamentoCondicaoSaudeTematicaEnum.DESENVOLVIMENTO_INFANTIL]: css`
    background-color: ${colors.turquoise.c60};
    color: ${theme.pallete.gray.c100};
  `,
  [AcompanhamentoCondicaoSaudeTematicaEnum.DIABETES]: css`
    background-color: ${colors.red.c20};
    color: ${theme.pallete.gray.c100};
  `,
  [AcompanhamentoCondicaoSaudeTematicaEnum.HIPERTENSAO_ARTERIAL]: css`
    background-color: ${colors.yellow.c40};
    color: ${theme.pallete.gray.c100};
  `,
  [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_MULHER]: css`
    background-color: ${colors.pink.c40};
    color: ${theme.pallete.gray.c100};
  `,
  [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_BUCAL]: css`
    background-color: ${colors.orange.c40};
    color: ${theme.pallete.surface.main};
  `,
})

const createStyles = (theme: Theme) => ({
  titleResultadosEncontrados: css`
    margin-bottom: 1rem;
  `,
  labelIvcf: css`
    font-size: 0.5rem;
    margin-right: 0.5rem;
  `,
  tagTematica: createTagTematicaStyles(theme),
  tagTria: css`
    background-color: ${colors.turquoise.c40};
    color: ${theme.pallete.surface.main};
    margin-right: 0.5rem;
  `,
  textTria: css`
    margin-left: 0.25rem;
  `,
})
